import { render } from "./DrawerMessenger.vue?vue&type=template&id=6fae2e7b&ts=true"
import script from "./DrawerMessenger.vue?vue&type=script&lang=ts"
export * from "./DrawerMessenger.vue?vue&type=script&lang=ts"

import exportComponent from "/home/starkoms/webapps/front-comm-starkoms/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__